import React from 'react';
import PropTypes from 'prop-types';

const ShortUrlField = ({ source, record = {} }) => {
  const value = record[source];
  if (value === null || value === undefined) {
    return <span />;
  }

  const href = value.startsWith('zpty.us') ? `//${value}` : value;

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};

ShortUrlField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

ShortUrlField.defaultProps = {
  record: {},
};

export default ShortUrlField;
